module.exports = __webpack_public_path__ + "img/9791187147053.0c58df98.jpg";